module.exports = {"title":"Success!","content":"The refund has been successful.","ok":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/RefundSuccessModal/locales/en.json
// module id = 1450
// module chunks = 0